import _ from 'lodash';
import Data from 'app-core/Data';
import ssmlHelper from 'view/insertion/ssml-helper';
import storage from 'storage';

export default {
	computed: {
		undoRedoOperations() {
			return {
				undoHistory: this.undoHistory,
				redoHistory: this.redoHistory,
				undoRedoHistory: this.undoRedoHistory,
				undo: this.undo,
				redo: this.redo
			}
		}
	},
	data() {
		return {
			showLinksAlways: storage.prop('showLinksAlways', void 0, false),
			focusedAggregatedTrack: null
		}
	},
	methods: {
		onDeleteTrack(track, silent) {
			if (track?.__aggregatedTrack?.__readonly) return;
			if (silent) {
				this.removeTrack(track, silent);
				this.calcVisibleTracks();
				return;
			}
			this.$confirmMessage({
				title: this.$tCaption('Confirm action', '@actions'),
				text: this.$tCaption('Are you sure you want to delete the insertion?'),
				handler: () => {
					this.removeTrack(track, silent);
					this.calcVisibleTracks();
				}
			});
		},
		onDeleteTracks(tracks) {
			if (this.readonly || !tracks?.length) return;
			this.$confirmMessage({
				title: this.$tCaption('Confirm action', '@actions'),
				text: this.$tCaption('Are you sure you want to delete the insertion(s)?'),
				handler: () => {
					tracks.map(f => this.removeTrack(f, true));
					this.calcVisibleTracks();
				}
			});
		},
		removeTrack(track, silent) {
			if (track?.__aggregatedTrack?.__readonly) return;
			track.__unlink();
			track.__linkedFrom.map(f => f?.track && f?.track?.__unlink());

			let removeTrack = () => {
				if (!silent)
					this.$notifySuccess('Insertion removed');
				if (track.__isSubTrack) {
					let parentTrack = this.loadedTracks.filter(f => f.id === track.insertion.ParentId)[0];
					if (parentTrack) {
						_.remove(parentTrack.subTracks, v => v.id === track.id);
						parentTrack.__totalSubInsertions--;
					}
				} else {
					if (track.subTracks)
						track.subTracks.map(f => _.remove(this.loadedTracks, v => v.id === f.id));
					_.remove(this.loadedTracks, v => v.id === track.id);
				}
				this.calcVisibleTracks();
			};

			track.__isDeleted = true;
			if (track.__isInsertionLoaded) {
				track.insertion.__isDeleted = true;
				track.__isLoading++;
				this.isLoading++;
				return Data.getExternalApi('Creative/DeleteInsertion', `insertionId=${track.id}`).then((r) => {
					if (r.Success) {
						if (track?.insertion?.Audio) {
							this.$creativeBlobsDb.delete(`${track?.insertion?.Audio?.AzureContainer ? `${track?.insertion?.Audio?.AzureContainer}--` : ''}${track?.insertion?.Audio?.FileName}`);
						}
						removeTrack();
					} else {
						if (!silent)
							this.$notifyError(r.ErrorMessage);
						track.__isLoading--;
					}
				}).finally(() => this.isLoading--);
			} else {
				removeTrack();
			}
		},
		onDeleteAggregatedTrack(trackNumber) {
			if (this.readonly) return;
			this.$confirmMessage({
				title: this.$tCaption('Confirm action', '@actions'),
				text: this.$tCaption('Are you sure you want to delete the track?'),
				handler: async () => {
					if (__DEBUG__)
						console.debug('Remove aggregated track', { trackNumber });
					let tracks = (this.loadedTracks || []).filter(f => f.__aggregatedTrack?.trackNumber === trackNumber);
					this.creative.JsonConfig.aggregatedTracks.splice(_.findIndex(this.creative.JsonConfig.aggregatedTracks, v => v.trackNumber === trackNumber), 1);
					tracks.map(f => this.removeTrack(f, true));
					this.calcVisibleTracks();
				}
			});
		},
		executeTrackAction(actionId, track, actionItem, aggregatedTrack) {
			if (__DEBUG__)
				console.debug('Execute track action', { actionId, track, actionItem, aggregatedTrack });

			if (actionId.indexOf('wapiPlugin_') > -1) {
				var pluginId = actionId.replace('wapiPlugin_', '');
				var pluginInstance = this.getActiveWapiPlugin(aggregatedTrack, pluginId);
				this.$refs.tracker?.showWAPIPluginInstance(aggregatedTrack, pluginId, pluginInstance);
				return;
			}

			if (actionItem?.isNetworkStudioAction) {
				this.exectureNetworkStudioTrackAction(actionId, track, actionItem, aggregatedTrack);
				return;
			}

			switch (actionId) {
				case 'addSubTrack':
					this.createInsertion(track.type, { ...track.insertion, JsonConfig: {} });
					break;
				case 'geoTarget':
					this.editingTrack = track;
					this.$refs.insertionEditor.showGeoTarget();
					break;
				case 'trackCriteria':
					this.$refs.aggregatedTrackCriteriaEditor.show(aggregatedTrack);
					break;
				case 'duplicate':
					this.duplicateTrack(track, false, {
						StartTime: parseInt((track.start + track.getTrimmedDuration()) * 1000),
					});
					break;
				case 'fileUploadRequest':
					this.$refs.fileUploadRequest.show(aggregatedTrack);
					break;
				case 'duplicateAggregatedTrack':
					if (aggregatedTrack) {
						this.$confirmMessage({
							title: this.$tCaption('Duplicate track?'),
							text: this.$tCaption('Do you want to duplicate this track with all clips?'),
							buttons: [
							{
								text: this.$tCaption('Yes', '@actions'),
								type: 'success',
								onClick: () => {
									let newAggTrack = this.createNewAggregatedTrack();
									_.assign(newAggTrack, {
										..._.cloneDeep(aggregatedTrack),
										trackNumber: newAggTrack.trackNumber
									});
									aggregatedTrack.__tracks.map(track => {
										this.duplicateTrack(track, true, {
											JsonConfig: {
												trackNumber: newAggTrack.trackNumber
											}
										});
									});
								}
							},
							{
								text: this.$tCaption('Track only', '@actions'),
								onClick: () => {
									let newAggTrack = this.createNewAggregatedTrack();
									_.assign(newAggTrack, {
										..._.cloneDeep(aggregatedTrack),
										trackNumber: newAggTrack.trackNumber
									});
								}
							},
							{
								type: 'normal',
								text: this.$tCaption('Cancel', '@actions')
							}]
						});
					}
					break;
				case 'split':
					if (track.type === 'textToSpeech') {
						this.editingTrack = track;
						this.textToSpeech.splitVisible = false;
						setImmediate(() => {
							if (this._isDestroyed) return;
							this.textToSpeech.splitVisible = true;
						});
					} else {
						this.$refs.tracker.applyTool(track, actionId, this.$refs.tracker.lastTime);
					}
					break;
				case 'splitSsmlSentences':
					this.$confirmMessage({
						title: this.$tCaption('Split sentences?'),
						text: this.$tCaption('Do you want to split sentences into separate audio files?'),
						buttons: [{
							text: this.$tCaption('Yes', '@actions'),
							onClick: () => {
								this.splitSsmlSentences(track);
							}
						}, {
							text: this.$tCaption('Cancel', '@actions')
						}]
					});
					break;
				case 'delete':
					this.onDeleteTrack(track);
					break;
				case 'deleteSubTracks':
					this.deleteSubTracks(track);
					break;
				case 'pluginsBank':
					this.focusedAggregatedTrack = aggregatedTrack;
					this.pluginsBankVisible = true;
					this.selectedPluginsBank = null;
					break;
				case 'recordAudio':
					this.editingTrack = track;
					this.$refs.tracker.recordVoice();
					break;
				case 'generateSubInsertions':
					this.$refs.subInsertionsGenerator.showPopup(this.$refs.tracker?.selectedTracks?.length > 1 ? this.$refs.tracker?.selectedTracks : [track]);
					break;
				case 'recordSubInsertions':
					this.editingTrack = track;
					this.$refs.subInsertionsRecorder.show();
					break;
				case 'edit':
					this.editInsertion(track);
					break;
				case 'link':
					this.linkingInsertion = track;
					this.linkingSourceType = 'both';
					break;
				case 'linkStart':
					this.linkingInsertion = track;
					this.linkingSourceType = 'start';
					break;
				case 'linkEnd':
					this.linkingInsertion = track;
					this.linkingSourceType = 'end';
					break;
				case 'unlink':
					track.__unlink();
					this.$notifySuccess(this.$tCaption('Link has been removed'));
					break;
				case 'unlinkStart':
					track.__unlink('start');
					this.$notifySuccess(this.$tCaption('Link has been removed'));
					break;
				case 'unlinkEnd':
					track.__unlink('end');
					this.$notifySuccess(this.$tCaption('Link has been removed'));
					break;
				case 'wapiPluginsManager':
					this.$refs.tracker.getTrackInfo(track)?.showWAPIPluginsManager();
					break;
				case 'translationQA':
					this.$refs.translationsQA.show([track?.insertion?.OriginalAudio]);
					break;
				case 'resetInsertion':
					this.$confirmMessage({
						title: this.$tCaption('Confirm action', '@actions'),
						text: this.$tCaption('Do you want to reset sound?'),
						handler: () => {
							_.assign(track.insertion.JsonConfig, {
								fadeIn: { value: 0, type: 'exponential' },
								fadeOut: { value: 0, type: 'exponential' },
								volumeEnvelope: {
									points: [],
									enabled: false
								},
								pitchEnvelope: {
									points: [],
									enabled: false
								}
							});
							track.startOffset = 0;
							track.endOffset = 0;
							track.__unlink();
						}
					});
					break;
				case 'normalize':
					this.$refs.tracker.getTrackInfo(track)?.showNormalizePopup();
					break;
				case 'exactLength':
					this.editingTrack = track;
					setImmediate(() => {
						this.$refs.tracker?.$refs?.exactLengthTool?.show();
					});
					break;
				case 'audioOverdubbingTool':
					this.$refs.audioOverdubbingTool?.show(track);
					break;
				case 'audioConversionTool':
					this.$refs.audioConversionTool?.show(track);
					break;
				case 'textBasedAudioEditor':
					this.$refs.textBasedAudioEditor?.show(track);
					break;
				case 'freeze-ssml':
					this.freezeSsml(track);
					break;
				default:
					this.$refs.tracker.applyTool(track, actionId);
					break;
			}
		},
		makeLink(track, linkType) {
			if (this.linkingInsertion) {
				this.linkingInsertion.__link(track, { sourceLinkType: this.linkingSourceType, linkType: linkType || 'end' });
				this.linkingInsertion = null;
				this.$notifySuccess(this.$tCaption('Link has been created'));
			}
		},
		deleteSubTracks(track) {
			this.$confirmMessage({
				title: this.$tCaption('Delete sub tracks?'),
				text: this.$tCaption('Do you want to delete all sub tracks?'),
				handler: () => {
					track.__isLoading++;
					this.$Data.getExternalApi('Creative/DeleteSubInsertions', `insertionId=${track.id}`).then(r => {
						if (r.Success !== false) {
							this.$notifySuccess('Subtracks have been removed');
							track.subTracks.map(f => {
								f.__isInsertionLoaded = false;
								this.removeTrack(f, true);
							});
							track.__loadSubTracks(true).then(() => {
								this.$eventsBus.$emit('update-tracker');
							});
						}
					}).finally(() => track.__isLoading--);
				}
			});
		},
		async duplicateTrack(trackData, silent, customInsertionData) {
			let track = trackData && trackData.sourceTrack || trackData;
			let duplicate = (withSubtracks) => {
				let insertion = {
					...track.insertion,
					CreativeId: this.creative.Oid,
					...(customInsertionData || {}),
					JsonConfig: {
						...track.insertion.JsonConfig,
						...(customInsertionData?.JsonConfig || {})
					},
					Oid: null
				};

				insertion.JsonConfig.linkedFrom = [];

				if (__DEBUG__)
					console.debug('Duplicating track', track, customInsertionData, insertion);
				let base64 = this.$refs.tracker.getTrackAudioBase64(track);
				this.isLoading++;
				return this.$Data.createUpdatePureInsertion(insertion).then(r => {
					if (__DEBUG__)
						console.debug('Insertion duplicated', { insertion, r, base64 });
					if (r.Success) {
						insertion.Oid = r.Data.Oid;

						this.$azure.duplicateBlobLink(track.insertion, r.Data);

						let newTrack = this.getTrackFromInsertion(insertion);
						newTrack.__isSubTrack = track.__isSubTrack;
						this.processAddTrack(newTrack);
						this.$refs.tracker.setBase64ForTrack(newTrack, base64);

						if (!track.__isSubTrack && track.subTracks && track.subTracks.length && withSubtracks) {
							track.subTracks.map(f => this.duplicateTrack({
								...f,
								insertion: { ...f.insertion, ParentId: newTrack.id }
							}, true));
						}

						newTrack.insertion?.JsonConfig?.linkedTo?.map(f => {
							const destTrack = this.allTracks.find(t => t.id === f.id);
							newTrack.__link(destTrack, f);
						});

						this.isLoading--;

						return newTrack;
					} else {
						this.$notifyError(r.ErrorMessage);
						this.isLoading--;
					}
					return null;
				}).catch(() => this.isLoading--);
			};

			if (silent) {
				return duplicate();
			}

			if (track.subTracks && track.subTracks.length) {
				this.$confirmMessage({
					title: 'Duplicate sub tracks?',
					text: 'Do you want to duplicate main sound with all sub tracks?',
					buttons: [{
						text: 'Yes',
						onClick: () => {
							duplicate(true);
						}
					}, {
						text: 'No',
						onClick: () => {
							duplicate();
						}
					}, {
						text: 'Cancel'
					}]
				});
			} else {
				this.$confirmMessage({
					title: 'Duplicate clip?',
					text: 'Do you want to duplicate this clip?',
					buttons: [{
						text: 'Yes',
						onClick: () => {
							duplicate();
						}
					}, {
						text: 'Cancel'
					}]
				});
			}
		},
		onAudioChanged(track, base64) {
			if (this.inMemory) return;
			this.isLoading++;
			this.$azure.uploadInsertionAudio(track.insertion, base64)
				.then(() => {
					if (__DEBUG__)
						console.debug('Audio insertion uploaded', { base64 });
				})
				.catch((ex) => {
					this.$notifyError(ex);
				})
				.finally(() => this.isLoading--);
		},
		splitSsml(inputTrack, splittedSsmlArray) {
			let track = inputTrack;
			let cloneTrack = {
				...track,
				id: null,
				insertion: {
					...track.insertion,
					Oid: null,
					Ssml: splittedSsmlArray[1]
				}
			}

			let ssml1 = this.$refs.insertionEditor.getSsml(this.$Data.formatObjectToLowerCase(track.insertion), splittedSsmlArray[0]);
			let ssml2 = this.$refs.insertionEditor.getSsml(this.$Data.formatObjectToLowerCase(cloneTrack.insertion), splittedSsmlArray[1]);

			this.textToSpeech.splitVisible = false;

			this.isLoading++;
			inputTrack.__isLoading++;
			Promise.all([
				this.$refs.insertionEditor.generateAudio(this.$Data.formatObjectToLowerCase(track.insertion), { ssml: ssml1 }),
				this.$refs.insertionEditor.generateAudio(this.$Data.formatObjectToLowerCase(cloneTrack.insertion), { ssml: ssml2 })
			]).then(audio => {
				let upload = (insertion, base64) => {
					this.isLoading++;
					return this.$azure.uploadInsertionAudio(insertion, base64)
						.then(() => {
							if (__DEBUG__)
								console.debug('Audio insertion uploaded', { base64 });
						})
						.catch((ex) => {
							this.$notifyError(ex);
						})
						.finally(() => this.isLoading--);
				};

				let promises = [];
				track.duration = audio[0].buffer.duration;
				track.insertion.Duration = parseInt(track.duration * 1000);
				track.insertion.Ssml = ssml1;
				promises.push(upload(track.insertion, audio[0].base64));
				this.$refs.tracker.setBase64ForTrack(track, audio[0].base64);
				this.isLoading++;
				promises.push(this.$Data.createUpdatePureInsertion(track.insertion).finally(() => this.isLoading--));

				let newTrackInsertion = {
					...track.insertion,
					CreativeId: this.creative.Oid,
					StartTime: parseInt((track.start + track.duration) * 1000),
					Duration: parseInt(audio[1].buffer.duration * 1000),
					Oid: null,
					Ssml: ssml2
				};

				if (__DEBUG__)
					console.debug('Duplicated SSML insertion', { newTrackInsertion, audio, ssml1, ssml2, splittedSsmlArray });

				this.isLoading++;
				this.$Data.createUpdatePureInsertion(newTrackInsertion).then(r => {
					if (r.Success) {
						newTrackInsertion.Oid = r.Data.Oid;

						let newTrack = this.getTrackFromInsertion(newTrackInsertion);
						newTrack.__isSubTrack = track.__isSubTrack;
						this.processAddTrack(newTrack);
						this.$refs.tracker.setBase64ForTrack(newTrack, audio[1].base64);
						promises.push(upload(newTrackInsertion, audio[1].base64));
					}
					return r;
				}).catch(ex => {
					console.error(ex);
					this.isLoading--;
				}).finally(() => this.isLoading--);
				return null;
			}).catch(ex => {
				console.error(ex);
			}).finally(() => {
				this.isLoading--;
				inputTrack.__isLoading--;
			});
		},
		async splitSsmlSentences(track) {
			let sentences = ssmlHelper.splitSsmlSentences(`${track?.insertion?.Ssml}`).map((ssml, i) => ({
				insertion: {
					...track.insertion,
					Oid: i === 0 ? track.insertion.Oid : null,
					Ssml: ssml
				},
				ssml
			}));

			if (__DEBUG__)
				console.debug('Split ssml sentences', { sentences });

			if (!sentences?.length) {
				this.$notifyWarning(this.$tCaption('No sentences in insertion'));
				return;
			}

			track.__isLoading++;
			try {
				let start = track.insertion.StartTime;
				for (let s = 0; s < sentences.length; s++) {
					let insertion = sentences[s].insertion;
					let ssml = sentences[s].ssml;
					let isNew = !insertion.Oid;
					let audio = await this.$refs.insertionEditor.generateAudio(this.$Data.formatObjectToLowerCase(insertion), { ssml: ssml });
					insertion.Duration = parseInt(audio.buffer.duration * 1000);
					insertion.Ssml = ssml;
					insertion.StartTime = parseInt(start);

					if (__DEBUG__)
						console.debug('Split ssml sentences insertion', { insertion });

					if (isNew)
						insertion = (await this.$Data.createUpdatePureInsertion(insertion))?.Data;
					this.$azure.uploadInsertionAudio(insertion, audio.base64);

					if (__DEBUG__)
						console.debug('Split ssml sentences insertion', { insertion, isNew, audio, start });

					start += insertion.Duration;

					if (isNew) {
						let newTrack = this.getTrackFromInsertion(insertion);
						newTrack.__isSubTrack = track.__isSubTrack;
						this.processAddTrack(newTrack);
						this.$refs.tracker.setBase64ForTrack(newTrack, audio.base64);
					} else {
						track.duration = audio.buffer.duration;
						track.insertion.Duration = parseInt(track.duration * 1000);
						track.insertion.Ssml = ssml;
						track.__saveInsertion();
						this.$refs.tracker.setBase64ForTrack(track, audio.base64);
					}
				}
			} finally {
				track.__isLoading--;
			}
		},
		focusedAggregatedTrackSsmlObject() {
			let track = this.$refs.tracker?.focusedAggregatedTrack;
			if (track) {
				return this.$refs.tracker?.getAggregatedTrackItems(track.trackNumber).filter(f => f?.type === 'textToSpeech')[0];
			}
		},
		onSubInsertionsGenerated(track) {
			if (__DEBUG__)
				console.debug('onSubInsertionsGenerated', { track });
			track.__isGeneratingSubInsertions = false;
			if (track) {
				track.__loadSubTracks(true);
				this.loadCreative();
			}
		},
		onSubInsertionsGenerationStarted(track) {
			if (track)
				track.__isGeneratingSubInsertions = true;
		},
		async showLastProcessingJobInfo(job, track) {
			this.isLoading++;
			if (track) track.__isLoading++;

			const jobEntity = ((await this.$Data.getExternalApi('PersistentJobEntity/List', `page=1&filterCriteria=['Oid', '=', '${job.Oid}']`, 1).finally(() => {
				this.isLoading--;
				if (track) track.__isLoading--;
			}))?.Results || [])[0];

			if (jobEntity) {
				if (__DEBUG__)
					console.debug('showLastProcessingJobInfo', { jobEntity });

				try {
					jobEntity.ResultJson = JSON.parse(jobEntity.ResultJson);
				} catch {
					//
				}

				//this.$notifyMessage(JSON.stringify(jobEntity, void 0, '  '), { fullScreen: true });

				this.$eventsBus.$emit('show-persistent-job-details', jobEntity);
			}
		},
		showUndoHistory() {
			if (this.$refs.undoHistory) this.$refs.undoHistory.show();
		}
	}
};
